export default __webpack_public_path__ + "static/media/organice.5121bc75.svg";